import { render, staticRenderFns } from "./editorDatumPopover.vue?vue&type=template&id=de088f28&"
import script from "./editorDatumPopover.vue?vue&type=script&lang=js&"
export * from "./editorDatumPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports